import type { FlagIcon } from '@constants/countryDetails'

export const Ch: FlagIcon = ({ testId, ...rest }) => (
  <svg viewBox='0 0 512 512' data-testid={testId} {...rest}>
    <circle cx='256' cy='256' r='256' fill='#d80027' />
    <path
      fill='#eee'
      d='M389.6 211.5h-89v-89h-89.1v89h-89v89h89v89h89v-89h89z'
    />
  </svg>
)
